









































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

import { statesList } from '@/utils/Utils';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import RadioField from '@/components/Form/RadioField.vue';

@Component({
	name: 'InvolvedInsuredsHealthCareProvidersGroupFields',
	components: {
		SelectField,
		TextField,
		RadioField,
	},
})
export default class InvolvedInsuredsHealthCareProvidersGroupFields extends Vue {
	@Prop() private values: any;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;

	private statesList: typeof statesList = statesList;
}
